import { BudgetPurpose } from '@common/graphql/generated';

export const getStatusColors = ({
    budgetPurpose,
    amountLeft,
}: {
    budgetPurpose: BudgetPurpose;
    amountLeft: number;
}): { text: string; progress: string; divider: string } => {
    const invert =
        budgetPurpose === 'income' || budgetPurpose === 'saving_investing';
    const isOver = invert ? amountLeft <= 0 : amountLeft < 0;

    return {
        text: invert
            ? isOver
                ? 'green.800'
                : 'gray.600'
            : isOver
              ? 'red.600'
              : 'green.800',
        progress: invert
            ? isOver
                ? 'green.700'
                : 'gray.600'
            : isOver
              ? 'orange.300'
              : 'green.700',
        divider: invert
            ? isOver
                ? 'green.800'
                : 'gray.600'
            : isOver
              ? 'red.600'
              : 'green.800',
    };
};
